import { getRegionKey } from "@certn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { LANGUAGE_OPTIONS } from "../constants";

export function useLanguage() {
  const { i18n } = useTranslation();
  const regionKey = getRegionKey();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (regionKey === "au") {
      i18n.changeLanguage("en-AU");
    }
    if (regionKey === "uk") {
      i18n.changeLanguage("en-GB");
    }
    document.documentElement.lang = i18n.resolvedLanguage || i18n.language;
  }, [i18n.language]);

  useEffect(() => {
    const locale = searchParams.get("locale");
    if (regionKey === "au") {
      i18n.changeLanguage("en-AU");
    }
    if (locale) {
      i18n.changeLanguage(locale);
    }
  }, []);

  const changeLanguage = async (locale: string) => {
    locale = regionKey === "au" ? "en-AU" : locale;
    i18n.changeLanguage(locale);
    window.location.reload();
  };

  const currentLanguageLabel = LANGUAGE_OPTIONS?.find(
    ({ value }) => value === i18n.language
  )?.display_value;

  return {
    changeLanguage,
    currentLanguageLabel,
  };
}
